import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { createAction } from '../../utils';
import FilterableDropdown from '../base/FilterableDropdown';
import ErrorFieldMessage from '../base/ErrorFieldMessage';
import {
  isShowError,
  firstError,
} from '../campaign/campaignCreation/CreateCampaignHandleError';
import { LanguageConfig } from '../../config/CustomEnums';
import { CustomTitleWithDropDown } from '../customer/CustomTitleWithDropDown';

function CustomerFilterableDropdown(props) {
  const selectCustomer = props.selectCustomer || (() => {});
  const filterableItemClassName = props.showMembershipId ? 'filterable-item-customer' : '';
  const defaultSelectedCustomer = props.defaultSelectedCustomer;
  const moreSearch = props.moreSearch || [];
  const needLevelFilter = props.needLevelFilter || false;
  const title = props.title;
  const titleTips = props.titleTips || '';
  const errorName = props.errorName || '';
  const errorMessage = props.errorMessage || '';
  const errorFields = props.errorFields || [];
  const { customers, levelList } = useSelector((state) => ({
    customers: state.customerList.customerList,
    levelList: state.levels.levelList,
  }));
  const dispatch = useDispatch();

  useEffect(() => {
    // dispatch(createAction('levels/getLevelList')({}));
    dispatch(createAction('customerList/getPagedCustomers')({ moreSearch }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    firstError(errorName, errorFields, LanguageConfig.english);
  }, [errorFields, errorName]);

  return (
    <>
      <CustomTitleWithDropDown
        title={title}
        titleTips={titleTips}
        source={customers}
        filterableItemClassName={filterableItemClassName}
        defaultValue={defaultSelectedCustomer}
        setValue={selectCustomer}
        loadMoreAction={'customerList/getPagedCustomers'}
        filterAction={'customerList/getPagedCustomers'}
        filterButtons={
          needLevelFilter ? levelList?.map((item) => item.name) : null
        }
        defaultFilter={{ moreSearch }}
        errors={errorFields}
        errorName={errorName}
        errorMessage={errorMessage}
        showRemoveButton={props.showRemoveButton}
        onRemoveButtonClick={props.onRemoveButtonClick}
      />
    </>
  );
}

export default CustomerFilterableDropdown;
